import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";

export class AutocompleteCompanyData {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) {}

  async run(cif: string): Promise<void> {
    let args = {cif:cif}
    let data = await this.dispatcher.dispatch('company.data', args)
    if (data.status === '200') {
      let b = await this.frontend.confirm(data)
      if(b){
        this.frontend.cru_cif = data.data['cif']
        this.frontend.cru_name = data.data['name']
        this.frontend.cru_alias = data.data['comercial_names'].toString()
        this.frontend.cru_address = data.data['address']
        this.frontend.cru_zip_code = data.data['zip_code']
        this.frontend.cru_province = data.data['province']
        this.frontend.cru_city = data.data['city']
        this.frontend.cru_country = data.data['country']
        this.frontend.cru_email = data.data['email']
        this.frontend.cru_phone = data.data['phones'].toString()
        this.frontend.cru_website = data.data['websites'].toString().split(',')[0]
      }
    }else {
      return await this.frontend.showNotFoundMessage()
    }
  }
}